import { render, staticRenderFns } from "./ClientViewSidebarAttachment.vue?vue&type=template&id=0eff3b1d&scoped=true"
import script from "./ClientViewSidebarAttachment.vue?vue&type=script&lang=ts"
export * from "./ClientViewSidebarAttachment.vue?vue&type=script&lang=ts"
import style0 from "./ClientViewSidebarAttachment.vue?vue&type=style&index=0&id=0eff3b1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eff3b1d",
  null
  
)

export default component.exports